// extracted by mini-css-extract-plugin
module.exports = {"shopAndAddressPicker":"header_shopAndAddressPicker__2d7f-","header__selectShop":"header_header__selectShop__18UIQ"};